import * as Sentry from '@sentry/react'

export const captureException = (e) => {
  Sentry.captureException(e)
}

export const captureChunkLoadError = (e) => {
  Sentry.captureException(e, { tags: { kind: 'chunk-load-error' } })
}

export const setUserId = (id) => {
  Sentry.setUser({ id })
}

export const clearUser = () => {
  Sentry.setUser(null)
}
